import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// Libs
// Components
import LoadingOverlay from 'react-loading-overlay';
import { toast } from 'react-toastify';
// Services
import { verifyToken, cleanRedirectState } from '../../../../state/services/authService';
import { getSubClients, updateSubClient } from '../../../../state/services/clientService';
// Constants


class ClientSubClient extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            childMUPercents: [],
        };
    }

    static propTypes = {
        verifyToken: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        redirect: PropTypes.bool.isRequired,
        cleanRedirectState: PropTypes.func.isRequired,
        urlAdminHome: PropTypes.string.isRequired,
        getSubClients: PropTypes.func.isRequired,
        subClients: PropTypes.array.isRequired,
        updateSubClient: PropTypes.func.isRequired,
    }

    componentDidMount() {
        const token = localStorage.getItem('token');

        if (token && token.length > 0) {
            this.props.verifyToken();
        } else {
            localStorage.setItem('isLoggedIn', 'false');
            this.props.cleanRedirectState();
            this.props.history.push('/customerdashboard/');
        }

        this.onClickRefresh();
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const { redirect, subClients } = newProps;
        const currentRoute = this.props.location.pathname;

        if (redirect && currentRoute != '/') {
            localStorage.setItem('isLoggedIn', 'false');
            this.props.cleanRedirectState();
            this.props.history.push('/customerdashboard');
        }

        if (subClients && subClients !== this.props.subClients) {
            this.notify('Refreshed!');

            this.setState({
                childMUPercents: subClients.map(c => {
                    return { pk_id_dme_client: c.pk_id_dme_client, value: c.parent_markup_percent };
                }),
                loading: false,
            });
        }
    }

    notify = (text) => {
        toast(text);
    };

    onClickRefresh() {
        this.setState({loading: true});
        this.props.getSubClients();
    }

    onInputChange(event, c) {
        event.preventDefault();
        const childMUPercents = this.state.childMUPercents;
        const index = childMUPercents.findIndex(item => item.pk_id_dme_client === c.pk_id_dme_client);
        childMUPercents[index].value = parseFloat(event.target.value);
        this.setState({ childMUPercents });
    }

    onInputBlur(event, childPercent) {
        event.preventDefault();
        const { subClients } = this.props;
        const subClient = subClients.filter(c => c.pk_id_dme_client === childPercent.pk_id_dme_client)[0];
        subClient['parent_markup_percent'] = childPercent['value'];
        this.props.updateSubClient(subClient);
    }

    render() {
        const { loading, childMUPercents } = this.state;
        const { subClients } = this.props;

        const subClientList = subClients.map((c, index) => {
            const childPercent = childMUPercents.filter(item=> item.pk_id_dme_client === c.pk_id_dme_client)[0];
            return (
                <tr key={index}>
                    <td>{c.pk_id_dme_client}</td>
                    <td>{c.company_name}</td>
                    <td>{c.parent_company_name}</td>
                    <td className="input-field-wrapper">
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Mark Up %"
                            value={childPercent.value}
                            onChange={(e) => this.onInputChange(e, childPercent)}
                            onBlur={(e) => this.onInputBlur(e, childPercent)}
                        />
                    </td>
                </tr>
            );
        });

        return (
            <div className="pricing-only">
                <div className="pageheader">
                    <h1>SubClient Management Page</h1>
                    <div className="breadcrumb-wrapper hidden-xs">
                        <span className="label">You are here:</span>
                        <ol className="breadcrumb">
                            <li><a href="/customerdashboard">Home</a>
                            </li>
                            <li className="active">Sub Clients</li>
                        </ol>
                    </div>
                </div>
                <section id="main-content" className="animated fadeInUp">
                    <LoadingOverlay
                        active={loading}
                        spinner
                        text='Loading...'
                    />
                    <div className="row">
                        <div className="panel-body">
                            <table id="example" className="table table-striped table-bordered" cellSpacing="0" width="100%">
                                <thead>
                                    <tr>
                                        <th>id</th>
                                        <th>Company Name</th>
                                        <th>Parent Company Name</th>
                                        <th>Mark Up Percent</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subClientList}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        redirect: state.auth.redirect,
        username: state.auth.username,
        subClients: state.client.subClients,
        urlAdminHome: state.url.urlAdminHome,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        verifyToken: () => dispatch(verifyToken()),
        cleanRedirectState: () => dispatch(cleanRedirectState()),
        getSubClients: () => dispatch(getSubClients()),
        updateSubClient: (subClient) => dispatch(updateSubClient(subClient)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientSubClient));



// WEBPACK FOOTER //
// ./src/pages/admin/CustomerViews/ClientSubClient/List.js